<div id="layout" class="theme-cyan">
  <app-project-leftmenu></app-project-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Projects Overview</h5>
                  </div>
                  <small class="text-truncate text-muted">Total 15 (last update 1hr ago)</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a class="nav-link text-muted" [routerLink]="['/app-project-add']" href="javascript:void(0)">Add</a>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0)">List view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Grid view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Add new</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>
              <ul class="nav nav-tabs tab-custom tab-sm d-inline-flex border-0" role="tablist">
                <li class="nav-item mb-0" role="presentation">
                  <a class="nav-link border-0 active" href="javascript:void(0)" (click)="onMenuTab('1')"
                    [ngClass]="{'active': listTab}">List view</a>
                </li>
                <li class="nav-item mb-0" role="presentation">
                  <a class="nav-link border-0" href="javascript:void(0)" (click)="onMenuTab('2')"
                    [ngClass]="{'active': gridTab}">Grid view</a>
                </li>
              </ul>
            </div>

          </div>

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container-fluid">

          <div class="tab-content">

            <!-- Project list view -->
            <div class="tab-pane fade show active" id="view-list" [ngClass]="{'show active': listTab}">
              <div class="card mb-3">
                <div class="table-responsive-xl">
                  <table class="table table-hover vertical-center mb-0">
                    <thead>
                      <tr>
                        <th class="border-top-0">Star</th>
                        <th class="border-top-0">Project</th>
                        <th class="border-top-0">Status</th>
                        <th class="border-top-0">Tasks Completed</th>
                        <th class="border-top-0">People</th>
                        <th class="border-top-0 text-end">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <a href="javascript:void(0)"><i class="zmdi zmdi-star-outline zmdi-hc-lg"></i></a>
                        </td>
                        <td>
                          <div class="fw-bold">
                            <a [routerLink]="['/app-project-detail']" href="javascript:void(0)" class="link">Ergonomic
                              real-time adapter</a>
                          </div>
                          <span class="text-muted">Last Edited by: Savanah Durgan <br>Sunday, 12 June, 2020</span>
                        </td>
                        <td>
                          <span class="badge bg-success bg-pill">Active</span>
                        </td>
                        <td>
                          <div class="mb-2 progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0"
                              aria-valuemax="100" style="width: 25%;"></div>
                          </div>
                          <div>Tasks Completed:<span class="text-inverse">36/94</span></div>
                        </td>
                        <td>
                          <div class="avatar">
                            <img class="avatar rounded-circle" src="../assets/images/xs/avatar2.jpg" alt="avatar">
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="dropdown" dropdown placement="bottom right">
                            <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                              id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                                class="zmdi zmdi-settings"></i></a>
                            <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                              role="menu" aria-labelledby="button-alignment">
                              <a class="dropdown-item" href="javascript:void(0)">Action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="javascript:void(0)"><i class="zmdi zmdi-star-outline zmdi-hc-lg"></i></a>
                        </td>
                        <td>
                          <div class="fw-bold">
                            <a [routerLink]="['/app-project-detail']" href="javascript:void(0)" class="link">Stand-alone
                              clear-thinking initiative</a>
                          </div>
                          <span class="text-muted">Last Edited by: Brando Gutkowski <br>Friday, 12 December, 2020</span>
                        </td>
                        <td>
                          <span class="badge bg-danger bg-pill">Suspended</span>
                        </td>
                        <td>
                          <div class="mb-2 progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100" style="width: 50%;"></div>
                          </div>
                          <div>Tasks Completed:<span class="text-inverse">36/94</span></div>
                        </td>
                        <td>
                          <div class="avatar">
                            <img class="avatar rounded-circle" src="../assets/images/xs/avatar1.jpg" alt="avatar">
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="dropdown" dropdown placement="bottom right">
                            <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                              id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                                class="zmdi zmdi-settings"></i></a>
                            <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                              role="menu" aria-labelledby="button-alignment">
                              <a class="dropdown-item" href="javascript:void(0)">Action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="javascript:void(0)"><i class="zmdi zmdi-star-outline zmdi-hc-lg"></i></a>
                        </td>
                        <td>
                          <div class="fw-bold">
                            <a [routerLink]="['/app-project-detail']" href="javascript:void(0)"
                              class="link">Configurable homogeneous knowledge user</a>
                          </div>
                          <span class="text-muted">Last Edited by: Wilmer Gorczany <br>Tuesday, 12 June, 2020</span>
                        </td>
                        <td>
                          <span class="badge bg-warning bg-pill">Waiting</span>
                        </td>
                        <td>
                          <div class="mb-2 progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                              aria-valuemax="100" style="width: 70%;"></div>
                          </div>
                          <div>Tasks Completed:<span class="text-inverse">36/94</span></div>
                        </td>
                        <td>
                          <div class="avatar">
                            <img class="avatar rounded-circle" src="../assets/images/xs/avatar3.jpg" alt="avatar">
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="dropdown" dropdown placement="bottom right">
                            <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                              id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                                class="zmdi zmdi-settings"></i></a>
                            <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                              role="menu" aria-labelledby="button-alignment">
                              <a class="dropdown-item" href="javascript:void(0)">Action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="javascript:void(0)"><i class="zmdi zmdi-star-outline zmdi-hc-lg"></i></a>
                        </td>
                        <td>
                          <div class="fw-bold">
                            <a [routerLink]="['/app-project-detail']" href="javascript:void(0)" class="link">Progressive
                              3rd generation superstructure</a>
                          </div>
                          <span class="text-muted">Last Edited by: Eden Green <br>Sunday, 12 September, 2020</span>
                        </td>
                        <td>
                          <span class="badge bg-secondary bg-pill">Paused</span>
                        </td>
                        <td>
                          <div class="mb-2 progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" aria-valuenow="90" aria-valuemin="0"
                              aria-valuemax="100" style="width: 90%;"></div>
                          </div>
                          <div>Tasks Completed:<span class="text-inverse">36/94</span></div>
                        </td>
                        <td>
                          <div class="avatar">
                            <img class="avatar rounded-circle" src="../assets/images/xs/avatar4.jpg" alt="avatar">
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="dropdown" dropdown placement="bottom right">
                            <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                              id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                                class="zmdi zmdi-settings"></i></a>
                            <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                              role="menu" aria-labelledby="button-alignment">
                              <a class="dropdown-item" href="javascript:void(0)">Action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="javascript:void(0)"><i class="zmdi zmdi-star-outline zmdi-hc-lg"></i></a>
                        </td>
                        <td>
                          <div class="fw-bold">
                            <a [routerLink]="['/app-project-detail']" href="javascript:void(0)" class="link">Virtual
                              intermediate portal</a>
                          </div>
                          <span class="text-muted">Last Edited by: Gregoria Hagenes <br>Friday, 12 October, 2020</span>
                        </td>
                        <td>
                          <span class="badge bg-success bg-pill">Active</span>
                        </td>
                        <td>
                          <div class="mb-2 progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0"
                              aria-valuemax="100" style="width: 25%;"></div>
                          </div>
                          <div>Tasks Completed:<span class="text-inverse">36/94</span></div>
                        </td>
                        <td>
                          <div class="avatar">
                            <img class="avatar rounded-circle" src="../assets/images/xs/avatar5.jpg" alt="avatar">
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="dropdown" dropdown placement="bottom right">
                            <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                              id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                                class="zmdi zmdi-settings"></i></a>
                            <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                              role="menu" aria-labelledby="button-alignment">
                              <a class="dropdown-item" href="javascript:void(0)">Action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="javascript:void(0)"><i class="zmdi zmdi-star-outline zmdi-hc-lg"></i></a>
                        </td>
                        <td>
                          <div class="fw-bold">
                            <a [routerLink]="['/app-project-detail']" href="javascript:void(0)" class="link">Visionary
                              client-server hardware</a>
                          </div>
                          <span class="text-muted">Last Edited by: Haskell Mills <br>Monday, 12 July, 2020</span>
                        </td>
                        <td>
                          <span class="badge bg-danger bg-pill">Suspended</span>
                        </td>
                        <td>
                          <div class="mb-2 progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100" style="width: 50%;"></div>
                          </div>
                          <div>Tasks Completed:<span class="text-inverse">36/94</span></div>
                        </td>
                        <td>
                          <div class="avatar">
                            <img class="avatar rounded-circle" src="../assets/images/xs/avatar6.jpg" alt="avatar">
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="dropdown" dropdown placement="bottom right">
                            <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                              id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                                class="zmdi zmdi-settings"></i></a>
                            <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                              role="menu" aria-labelledby="button-alignment">
                              <a class="dropdown-item" href="javascript:void(0)">Action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="javascript:void(0)"><i class="zmdi zmdi-star-outline zmdi-hc-lg"></i></a>
                        </td>
                        <td>
                          <div class="fw-bold">
                            <a [routerLink]="['/app-project-detail']" href="javascript:void(0)" class="link">Focused
                              context-sensitive hardware</a>
                          </div>
                          <span class="text-muted">Last Edited by: Rey Hansen <br>Friday, 12 May, 2020</span>
                        </td>
                        <td>
                          <span class="badge bg-warning bg-pill">Waiting</span>
                        </td>
                        <td>
                          <div class="mb-2 progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                              aria-valuemax="100" style="width: 70%;"></div>
                          </div>
                          <div>Tasks Completed:<span class="text-inverse">36/94</span></div>
                        </td>
                        <td>
                          <div class="avatar">
                            <img class="avatar rounded-circle" src="../assets/images/xs/avatar7.jpg" alt="avatar">
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="dropdown" dropdown placement="bottom right">
                            <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                              id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                                class="zmdi zmdi-settings"></i></a>
                            <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                              role="menu" aria-labelledby="button-alignment">
                              <a class="dropdown-item" href="javascript:void(0)">Action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a [routerLink]="['/app-project-detail']" href="javascript:void(0)"><i
                              class="zmdi zmdi-star-outline zmdi-hc-lg"></i></a>
                        </td>
                        <td>
                          <div class="fw-bold">
                            <a href="javascript:void(0)" class="link">Advanced mission-critical groupware</a>
                          </div>
                          <span class="text-muted">Last Edited by: Carey Runolfsson <br>Friday, 12 May, 2020</span>
                        </td>
                        <td>
                          <span class="badge bg-secondary bg-pill">Paused</span>
                        </td>
                        <td>
                          <div class="mb-2 progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" aria-valuenow="90" aria-valuemin="0"
                              aria-valuemax="100" style="width: 90%;"></div>
                          </div>
                          <div>Tasks Completed:<span class="text-inverse">36/94</span></div>
                        </td>
                        <td>
                          <div class="avatar">
                            <img class="avatar rounded-circle" src="../assets/images/xs/avatar8.jpg" alt="avatar">
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="dropdown" dropdown placement="bottom right">
                            <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                              id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                                class="zmdi zmdi-settings"></i></a>
                            <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                              role="menu" aria-labelledby="button-alignment">
                              <a class="dropdown-item" href="javascript:void(0)">Action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="javascript:void(0)"><i class="zmdi zmdi-star-outline zmdi-hc-lg"></i></a>
                        </td>
                        <td>
                          <div class="fw-bold">
                            <a [routerLink]="['/app-project-detail']" href="javascript:void(0)"
                              class="link">De-engineered tertiary matrix</a>
                          </div>
                          <span class="text-muted">Last Edited by: Jacynthe Beier <br>Wednesday, 12 May, 2020</span>
                        </td>
                        <td>
                          <span class="badge bg-success bg-pill">Active</span>
                        </td>
                        <td>
                          <div class="mb-2 progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0"
                              aria-valuemax="100" style="width: 25%;"></div>
                          </div>
                          <div>Tasks Completed:<span class="text-inverse">36/94</span></div>
                        </td>
                        <td>
                          <div class="avatar">
                            <img class="avatar rounded-circle" src="../assets/images/xs/avatar9.jpg" alt="avatar">
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="dropdown" dropdown placement="bottom right">
                            <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                              id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                                class="zmdi zmdi-settings"></i></a>
                            <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                              role="menu" aria-labelledby="button-alignment">
                              <a class="dropdown-item" href="javascript:void(0)">Action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <a href="javascript:void(0)"><i class="zmdi zmdi-star-outline zmdi-hc-lg"></i></a>
                        </td>
                        <td>
                          <div class="fw-bold">
                            <a [routerLink]="['/app-project-detail']" href="javascript:void(0)" class="link">Progressive
                              4th generation emulation</a>
                          </div>
                          <span class="text-muted">Last Edited by: Baby Robel <br>Thursday, 12 March, 2020</span>
                        </td>
                        <td>
                          <span class="badge bg-danger bg-pill">Suspended</span>
                        </td>
                        <td>
                          <div class="mb-2 progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100" style="width: 50%;"></div>
                          </div>
                          <div>Tasks Completed:<span class="text-inverse">36/94</span></div>
                        </td>
                        <td>
                          <div class="avatar">
                            <img class="avatar rounded-circle" src="../assets/images/xs/avatar10.jpg" alt="avatar">
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="dropdown" dropdown placement="bottom right">
                            <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                              id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                                class="zmdi zmdi-settings"></i></a>
                            <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                              role="menu" aria-labelledby="button-alignment">
                              <a class="dropdown-item" href="javascript:void(0)">Action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                              <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- pagination -->
              <nav>
                <ul class="pagination pagination-custom">
                  <li class="page-item"><a class="page-link" href="javascript:void(0)">Previous</a></li>
                  <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0)">Next</a></li>
                </ul>
              </nav>
            </div>

            <!-- Project grid view -->
            <div class="tab-pane fade" id="view-grid" [ngClass]="{'show active': gridTab}">
              <div class="row row-cols-1 row-cols-md-2 g-3">
                <div class="col">
                  <div class="card">
                    <div class="card-body">
                      <span class="mb-2 badge bg-success rounded-0 label-absolute">Active</span>
                      <h6><a [routerLink]="['/app-project-detail']" href="javascript:void(0)">Polarised stable frame</a>
                      </h6>
                      <span class="text-muted">Last Edited by: Caden Brakus <br>Saturday, 12 September, 2020</span>
                      <div class="mt-3">
                        <div class="mb-1 progress" style="height: 3px;">
                          <div class="progress-bar" role="progressbar" aria-valuenow="45" aria-valuemin="0"
                            aria-valuemax="100" style="width: 45%;"></div>
                        </div>
                        <small>Tasks Completed: <span class="text-inverse">36/94</span></small>
                      </div>
                      <div class="mt-3">
                        <div class="avatar-list avatar-list-stacked">
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar1.jpg" data-bs-toggle="tooltip"
                            title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar2.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Martin">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar3.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Terry">
                        </div>
                      </div>
                    </div>
                    <div class="d-flex card-footer">
                      <a href="javascript:void(0)" class="align-self-center me-2"><i
                          class="zmdi zmdi-star-outline"></i></a>
                      <span class="align-self-center">20 Sep, Fri, 2020</span>
                      <div class="align-self-center ms-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                            id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                              class="zmdi zmdi-settings"></i></a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a class="dropdown-item" href="javascript:void(0)">Action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card">
                    <div class="card-body">
                      <span class="mb-2 badge bg-secondary rounded-0 label-absolute">Paused</span>
                      <h6><a [routerLink]="['/app-project-detail']" href="javascript:void(0)">Synergized upward-trending
                          info-mediaries</a></h6>
                      <span class="text-muted">Last Edited by: Keely West <br>Saturday, 12 September, 2020</span>
                      <div class="mt-3">
                        <div class="mb-1 progress" style="height: 3px;">
                          <div class="progress-bar" role="progressbar" aria-valuenow="23" aria-valuemin="0"
                            aria-valuemax="100" style="width: 23%;"></div>
                        </div>
                        <small>Tasks Completed: <span class="text-inverse">36/94</span></small>
                      </div>
                      <div class="mt-3">
                        <div class="avatar-list avatar-list-stacked">
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar4.jpg" data-bs-toggle="tooltip"
                            title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar5.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Martin">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar6.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Terry">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar7.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Terry">
                        </div>
                      </div>
                    </div>
                    <div class="d-flex card-footer">
                      <a href="javascript:void(0)" class="align-self-center me-2"><i
                          class="zmdi zmdi-star-outline"></i></a>
                      <span class="align-self-center">13 Sep, Fri, 2020</span>
                      <div class="align-self-center ms-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                            id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                              class="zmdi zmdi-settings"></i></a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a class="dropdown-item" href="javascript:void(0)">Action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card">
                    <div class="card-body">
                      <span class="mb-2 badge bg-warning rounded-0 label-absolute">Waiting</span>
                      <h6><a [routerLink]="['/app-project-detail']" href="javascript:void(0)">Automated systemic
                          benchmark</a></h6>
                      <span class="text-muted">Last Edited by: Rod Koelpin <br>Saturday, 12 September, 2020</span>
                      <div class="mt-3">
                        <div class="mb-1 progress" style="height: 3px;">
                          <div class="progress-bar" role="progressbar" aria-valuenow="80" aria-valuemin="0"
                            aria-valuemax="100" style="width: 80%;"></div>
                        </div>
                        <small>Tasks Completed: <span class="text-inverse">36/94</span></small>
                      </div>
                      <div class="mt-3">
                        <div class="avatar-list avatar-list-stacked">
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar6.jpg" data-bs-toggle="tooltip"
                            title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar7.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Terry">
                        </div>
                      </div>
                    </div>
                    <div class="d-flex card-footer">
                      <a href="javascript:void(0)" class="align-self-center me-2"><i class="zmdi zmdi-star"></i></a>
                      <span class="align-self-center">20 Sep, Fri, 2020</span>
                      <div class="align-self-center ms-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                            id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                              class="zmdi zmdi-settings"></i></a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a class="dropdown-item" href="javascript:void(0)">Action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card">
                    <div class="card-body">
                      <span class="mb-2 badge bg-danger rounded-0 label-absolute">Suspended</span>
                      <h6><a [routerLink]="['/app-project-detail']" href="javascript:void(0)">Diverse transitional
                          strategy</a></h6>
                      <span class="text-muted">Last Edited by: Flavio Bayer <br>Saturday, 12 September, 2020</span>
                      <div class="mt-3">
                        <div class="mb-1 progress" style="height: 3px;">
                          <div class="progress-bar" role="progressbar" aria-valuenow="72" aria-valuemin="0"
                            aria-valuemax="100" style="width: 72%;"></div>
                        </div>
                        <small>Tasks Completed: <span class="text-inverse">36/94</span></small>
                      </div>
                      <div class="mt-3">
                        <div class="avatar-list avatar-list-stacked">
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar6.jpg" data-bs-toggle="tooltip"
                            title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar7.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Terry">
                        </div>
                      </div>
                    </div>
                    <div class="d-flex card-footer">
                      <a href="javascript:void(0)" class="align-self-center me-2"><i class="zmdi zmdi-star"></i></a>
                      <span class="align-self-center">20 Sep, Fri, 2020</span>
                      <div class="align-self-center ms-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                            id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                              class="zmdi zmdi-settings"></i></a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a class="dropdown-item" href="javascript:void(0)">Action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card">
                    <div class="card-body">
                      <span class="mb-2 badge bg-success rounded-0 label-absolute">Active</span>
                      <h6><a [routerLink]="['/app-project-detail']" href="javascript:void(0)">Polarised stable frame</a>
                      </h6>
                      <span class="text-muted">Last Edited by: Caden Brakus <br>Saturday, 12 September, 2020</span>
                      <div class="mt-3">
                        <div class="mb-1 progress" style="height: 3px;">
                          <div class="progress-bar" role="progressbar" aria-valuenow="55" aria-valuemin="0"
                            aria-valuemax="100" style="width: 55%;"></div>
                        </div>
                        <small>Tasks Completed: <span class="text-inverse">36/94</span></small>
                      </div>
                      <div class="mt-3">
                        <div class="avatar-list avatar-list-stacked">
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar1.jpg" data-bs-toggle="tooltip"
                            title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar2.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Martin">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar3.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Terry">
                        </div>
                      </div>
                    </div>
                    <div class="d-flex card-footer">
                      <a href="javascript:void(0)" class="align-self-center me-2"><i
                          class="zmdi zmdi-star-outline"></i></a>
                      <span class="align-self-center">5 Nov, Fri, 2020</span>
                      <div class="align-self-center ms-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                            id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                              class="zmdi zmdi-settings"></i></a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a class="dropdown-item" href="javascript:void(0)">Action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card">
                    <div class="card-body">
                      <span class="mb-2 badge bg-secondary rounded-0 label-absolute">Paused</span>
                      <h6><a [routerLink]="['/app-project-detail']" href="javascript:void(0)">Synergized upward-trending
                          info-mediaries</a></h6>
                      <span class="text-muted">Last Edited by: Keely West <br>Saturday, 12 September, 2020</span>
                      <div class="mt-3">
                        <div class="mb-1 progress" style="height: 3px;">
                          <div class="progress-bar" role="progressbar" aria-valuenow="68" aria-valuemin="0"
                            aria-valuemax="100" style="width: 68%;"></div>
                        </div>
                        <small>Tasks Completed: <span class="text-inverse">36/94</span></small>
                      </div>
                      <div class="mt-3">
                        <div class="avatar-list avatar-list-stacked">
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar4.jpg" data-bs-toggle="tooltip"
                            title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar5.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Martin">
                          <img class="avatar xs rounde ml-1" src="../assets/images/xs/avatar6.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Terry">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar7.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Terry">
                        </div>
                      </div>
                    </div>
                    <div class="d-flex card-footer">
                      <a href="javascript:void(0)" class="align-self-center me-2"><i class="zmdi zmdi-star"></i></a>
                      <span class="align-self-center">15 Oct, Fri, 2020</span>
                      <div class="align-self-center ms-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                            id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                              class="zmdi zmdi-settings"></i></a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a class="dropdown-item" href="javascript:void(0)">Action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card">
                    <div class="card-body">
                      <span class="mb-2 badge bg-warning rounded-0 label-absolute">Waiting</span>
                      <h6><a [routerLink]="['/app-project-detail']" href="javascript:void(0)">Automated systemic
                          benchmark</a></h6>
                      <span class="text-muted">Last Edited by: Rod Koelpin <br>Saturday, 12 September, 2020</span>
                      <div class="mt-3">
                        <div class="mb-1 progress" style="height: 3px;">
                          <div class="progress-bar" role="progressbar" aria-valuenow="91" aria-valuemin="0"
                            aria-valuemax="100" style="width: 91%;"></div>
                        </div>
                        <small>Tasks Completed: <span class="text-inverse">36/94</span></small>
                      </div>
                      <div class="mt-3">
                        <div class="avatar-list avatar-list-stacked">
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar6.jpg" data-bs-toggle="tooltip"
                            title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar7.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Terry">
                        </div>
                      </div>
                    </div>
                    <div class="d-flex card-footer">
                      <a href="javascript:void(0)" class="align-self-center me-2"><i class="zmdi zmdi-star"></i></a>
                      <span class="align-self-center">14 Sep, Fri, 2020</span>
                      <div class="align-self-center ms-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a class="btn btn-link text-muted dropdown-toggle" href="javascript:void(0)"
                            id="button-alignment" dropdownToggle type="button" aria-controls="dropdown-alignment"><i
                              class="zmdi zmdi-settings"></i></a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a class="dropdown-item" href="javascript:void(0)">Action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
